import { getData } from '../assets/scripts/GeneralFunctions'

export const lazyLoadHandler = async (
  url,
  title,
  list,
  count = 10,
  lazy_load_data,
  setLazyLoadData,
  obj_data,
  is_all_items_load,
  setAllLoad,
  setCars,
  propsSearchValue,
  selectedPeriod
) => {
  const { offsetHeight, scrollTop } = obj_data.target
  if (offsetHeight + scrollTop + 1 >= obj_data.target.scrollHeight) {
    if (list?.length % count === 0 && is_all_items_load) {
      let queryParams = { ...lazy_load_data, offset: list.length }
      setCars([...list, NaN, NaN])
      if (selectedPeriod?.length === 2) {
        queryParams = {
          ...queryParams,
          start: selectedPeriod[0],
          end: selectedPeriod[1],
        }
      }

      if (propsSearchValue) {
        queryParams = {
          ...queryParams,
          search: propsSearchValue,
        }
      }

      const moreData = await getData(url, 'get', queryParams, true)
      if (moreData) {
        setLazyLoadData(queryParams)
        if (moreData.data[title].length < count) {
          setAllLoad(false)
        }
        setCars(list.concat(moreData.data[title]))
      }
    }
  }
}
